export enum BadgeSeverity {
  INFO = 'info',
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  NEW = 'new'
}